import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ViewHorzPane = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M20 4H3c-.6 0-1 .4-1 1v14c0 .6.4 1 1 1h17c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1zm0 15H3v-6h17v6zM3 12V6h17v6H3z" />
  </SvgIcon>
);

export default ViewHorzPane;
